import type { PolicyDto } from 'korint-sdk';
import type { FormSections } from 'korint-sdk/react';

export const retailSubscriptionFeeSection: FormSections[number] = {
  fields: [
    {
      name: 'retailSubscriptionFee',
      required: true,
      type: 'number',
      apiDataAccessor: (data: PolicyDto) => {
        const retailSubscriptionFee = data?.quote?.components?.find(
          c => c.id === 'RETAIL_SUBSCRIPTION_FEE',
        );

        return (
          Math.round((retailSubscriptionFee?.premium?.amountWithFeesAndTaxes ?? 0) as number) / 100
        );
      },
      formDataAccessor: data => ({
        retailSubscriptionFeeComponent: {
          id: 'RETAIL_SUBSCRIPTION_FEE',
          type: 'FEE',
          chargeType: 'ONE_TIME',
          premium: {
            amountPreFeesAndTaxes: 0,
            totalFees: Math.round(((data.retailSubscriptionFee ?? 0) as number) * 100),
            totalTaxes: 0,
          },
        },
      }),
    },
  ],
};
